"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSubscriptionsReplacementQuery = useSubscriptionsReplacementQuery;
var _checkoutUtils = require("@ori/checkout-utils");
var _environment = require("@ori/environment");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _contexts = require("../contexts");
var _logger = require("../logger");
function useSubscriptionsReplacementQuery(subscriptionsItemCodes) {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    isPersonalSubscriptionsEnabled
  } = (0, _contexts.useBasketContext)();
  const params = {
    itemCodes: subscriptionsItemCodes
  };

  // logDebug('useSubscriptionsReplacementQuery() hook called, params:', params);

  const swrOptions = {
    enabled: isPersonalSubscriptionsEnabled === false,
    ..._checkoutUtils.errorHandlingSwrOptions,
    onSuccess: () => {
      (0, _logger.logDebug)('useSubscriptionsReplacementQuery() hook finished successfully');
    }
  };
  const {
    data: {
      productReplacementCollection: subscriptionItemInfo = []
    } = {},
    error: subscriptionQueryError,
    isValidating: isSubscriptionsReplacementsLoading
  } = (0, _staticApiClientReact.useGetTenantSubscriptionReplacements)(tenant, params, {
    swr: swrOptions
  });
  return {
    subscriptionQueryError,
    subscriptionItemInfo,
    isSubscriptionsReplacementsLoading
  };
}